import React from 'react';
import Layout from 'components/Layout';
import OfferEndpage from 'containers/OfferEndpage';

import { carItemRequest, setCarItem } from 'actions/carsActions';
import { setBreadcrumbs } from 'actions/app/breadcrumbs';
import { makeLocalize } from 'locales';

import { seoItemTitle, seoItemOgp } from './seo';
import { getRegionUrl, getMakeUrl, getModelUrl } from '../seo/urls';
import notFound from '../not-found';
import messages from './messages';

async function action(args) {
  const { params, fetch, store, intl } = args;
  const localize = makeLocalize(intl, messages);
  const car = await carItemRequest(fetch, params.id);
  if (!car) {
    return notFound(args);
  }

  const { location, make, model } = car;
  store.dispatch(setCarItem(car));
  store.dispatch(
    setBreadcrumbs([
      { title: 'Avtoprod', href: '/' },
      { title: localize('Пошук легкових'), href: '/cars' },
      { title: location.title, href: getRegionUrl(location) },
      { title: make.title, href: getMakeUrl(make) },
      { title: model.title, href: getModelUrl(make, model) },
      { title: car.title, active: true },
    ]),
  );

  return {
    chunks: ['caritem'],
    title: seoItemTitle({ car, localize }),
    seo: {
      ogp: seoItemOgp({ car, localize }),
    },
    component: (
      <Layout>
        <OfferEndpage id={params.id} />
      </Layout>
    ),
  };
}

export default action;
